import i18n from './surveys/geo/ru.json';
export default require(`./surveys/geo/${process.env.BEM_LANG}.json`) as typeof i18n;